<template>
  <CCard>
    <CCardHeader>
      <strong>{{ this.$lang.dashboard.header.recent_inquiry }}</strong>
      <span style="float: right;">
        <CBadge color="success">{{ count }}</CBadge>
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable class="mb-0 table-outline" hover :items="tableItems" :fields="tableFields"
                  @row-clicked="rowClickHandler" head-color="light" no-sorting>
        <td slot="name" slot-scope="{ item }">
          <span :title="item.name">{{ trimfunction(item.name, 15) }}</span>
        </td>
        <td slot="email" slot-scope="{ item }">
          <span :title="item.email">{{ trimfunction(item.email, 15) }}</span>
        </td>
        <td slot="description" slot-scope="{ item }">
          <span :title="item.description">{{ trimfunction(item.description, 15) }}</span>
        </td>
      </CDataTable>
      <CRow v-if="showProfile" style="margin-top: 2px">
        <CCol class="col-12 text-right">
          <button title="View All Profile" v-on:click="viewInquirys" class="btn btn-light btn-block mb-1">
            View All
          </button>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import store from "../../store/store";
import {Mixin} from "/src/mixins/index.js";
import {dashboardrecentInquiryList} from "../../store/url";

Vue.use(ServerTable, {}, false);
export default {
  name: "RecentInquiry",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      count: 0,
      showProfile: false,
      moduleDashboardrecentInquiryList: dashboardrecentInquiryList,
      tableItems: [],
      tableFields: [
        {key: "name", label: this.$lang.dashboard.recentInquiry.name},
        {key: "email", label: this.$lang.dashboard.recentInquiry.email},
        {key: "description", label: this.$lang.dashboard.recentInquiry.description},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.listUrlApi(this.moduleDashboardrecentInquiryList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.data.length > 0) {
            self.showProfile = true;
          }
        });
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `inquiry/view/${item.id}`});
    },
    viewInquirys() {
      this.$router.push({path: `inquiry`});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
